import {Component, Input, OnInit} from '@angular/core';
import {AlertController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {DatePicker} from '@ionic-native/date-picker/ngx';
import {LokijsService} from '../../services/database/lokijs.service';
import {TimeLoggerDTOModel} from '../../models/time-logger-DTO.model';
import {FindGeoLocationService} from '../../services/find-geo-location.service';

@Component({
    selector: 'time-clocking',
    templateUrl: './time-clocking.component.html',
    styleUrls: ['./time-clocking.component.scss'],
})
export class TimeClockingComponent implements OnInit {

    @Input() document = new DocumentModel();
    timeIn: Date;
    timeOut: Date;
    timeClockingDTO = new TimeLoggerDTOModel();
    timeLogs = [];
    timeEntry: number;
    totalHours = 0;

    constructor(private datePicker: DatePicker,
                private loki: LokijsService,
                private alertController: AlertController,
                private findGeoLocation: FindGeoLocationService) {
    }

    ngOnInit() {
        this.processTimeLogs();
        console.log(this.document);
    }

    async clockTick() {
        const alert = await this.alertController.create({
            header: 'Select Date/Time',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'date',
                    type: 'date',
                    value: this.generateDate().date
                },
                // input date without min nor max
                {
                    name: 'time',
                    type: 'time',
                    value: this.generateDate().time
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('Confirm Cancel');
                    }
                }, {
                    text: 'Ok',
                    handler: data => {
                        console.log(data);
                        this.insertDate(this.formDate(data.date, data.time));
                    }
                }
            ]
        });

        await alert.present();
    }

    generateDate() {
        const mDate = new Date().toISOString();
        return {'date': mDate.substr(0, 10), 'time': mDate.substr(11, 5)};
    }

    formDate(date: string, time: string) {
        const year = date.substr(0, 4);
        const month = date.substr(5, 2);
        const day = date.substr(8, 2);
        const hour = time.substr(0, 2);
        const min = time.substr(3, 2);

        const resDate = new Date();
        resDate.setFullYear(+year, +month - 1, +day);
        resDate.setHours(+hour, +min);

        return resDate;
    }

    insertDate(date) {
        if (!this.document.serviceJob.timeLogger) {
            this.document.serviceJob.timeLogger = new Array<TimeLoggerDTOModel>();
        }
        this.timeClockingDTO = new TimeLoggerDTOModel();
        this.timeClockingDTO.type = this.document.clockingState;
        this.findGeoLocation.getCurrentPositionCordova().then(result => {
            this.timeClockingDTO.lat = result.latitude;
            this.timeClockingDTO.lng = result.longitude;
        });
        if (this.document.clockingState === 1) {
            this.timeIn = date;
            this.timeClockingDTO.dateLogged = date.toISOString();
            this.document.clockingState = 2;
        } else if (this.document.clockingState === 2) {
            this.timeOut = date;
            this.timeClockingDTO.dateLogged = date.toISOString();
            this.document.clockingState = 1;
        }
        this.document.serviceJob.timeLogger.push(this.timeClockingDTO);
        this.processTimeLogs();
        this.loki.upsert('document', '$loki', this.document);
    }

    processTimeLogs() {
        let timeIn = 0;
        let timeOut = 0;
        this.timeLogs = [];
        this.totalHours = 0;
        if (this.document.serviceJob.timeLogger
            && this.document.serviceJob.timeLogger.length > 0
            && this.document.serviceJob.timeLogger.length % 2 === 0) {
            for (let i = 0; i < this.document.serviceJob.timeLogger.length; i += 2) {
                console.log(this.document.serviceJob.timeLogger[i], this.document.serviceJob.timeLogger[i + 1]);
                timeIn = new Date(this.document.serviceJob.timeLogger[i].dateLogged).getTime();
                timeOut = new Date(this.document.serviceJob.timeLogger[i + 1].dateLogged).getTime();
                this.document.serviceJob.timeLogger[i].timeLogged = 0;
                this.document.serviceJob.timeLogger[i + 1].timeLogged = this.timeInHours(timeIn, timeOut);
                console.log(timeIn, timeOut);
                this.timeEntry = this.timeInHours(timeIn, timeOut);
                this.totalHours += this.timeEntry;
                this.timeLogs.push({'date': this.document.serviceJob.timeLogger[i].dateLogged, 'duration': this.timeEntry});
            }

        }
    }

    timeInHours(timeIn: number, timeOut: number) {
        return (((timeOut - timeIn) / 1000) / 60) / 60;
    }

    round(duration: any) {
        return Math.floor(duration);
    }
}

// Code to process the timezone before forming the ISO String
Date.prototype.toISOString = function () {
    const tzo = -this.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function (num) {
            const norm = Math.floor(Math.abs(num));
            return (norm < 10 ? '0' : '') + norm;
        };
    return this.getFullYear() +
        '-' + pad(this.getMonth() + 1) +
        '-' + pad(this.getDate()) +
        'T' + pad(this.getHours()) +
        ':' + pad(this.getMinutes()) +
        ':' + pad(this.getSeconds()) +
        dif + pad(tzo / 60) +
        ':' + pad(tzo % 60);
};
